// extracted by mini-css-extract-plugin
module.exports = {"root":"az_J-b","certonaPartCard":"az_K-b","svgForOos":"az_L-b"};